import { render, staticRenderFns } from "./shopWallet.vue?vue&type=template&id=d579033e&scoped=true&"
import script from "./shopWallet.vue?vue&type=script&lang=js&"
export * from "./shopWallet.vue?vue&type=script&lang=js&"
import style0 from "./shopWallet.vue?vue&type=style&index=0&id=d579033e&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d579033e",
  null
  
)

export default component.exports